import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { DatetimeComponent } from './datetime.component';
import { TranslateModule } from '@ngx-translate/core';
@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule
    ],
    declarations: [
        DatetimeComponent,
    ],
    exports: [
        DatetimeComponent
    ]
})

export class DatetimeModule { }
